var YouLi = YouLi ? YouLi : {};
YouLi.Trip = YouLi.Trip ? YouLi.Trip : {};
YouLi.Trip.Checkout = YouLi.Trip.Checkout ? YouLi.Trip.Checkout : {};

(function (YouLi) {
    (function (Trip) {
        (function (Checkout) {

            let prevState = {
                isPackageCategory: false
            }

            YouLi.Trip.Checkout.PaymentGateway = {  
                Stripe: 0,
                Square: 1,
                CyberSource: 2,
                AuthorizeNet: 3
            };
            YouLi.Trip.Checkout.ConnectedPaymentGateway = YouLi.Trip.Checkout.PaymentGateway.Stripe;
            YouLi.Trip.Checkout.StripeHandler = undefined;
            YouLi.Trip.Checkout.AuthorizeNetClientKey = "";
            YouLi.Trip.Checkout.AuthorizeNetAPIKey = "";
            YouLi.Trip.Checkout.Name = "";
            YouLi.Trip.Checkout.Description = "";
            YouLi.Trip.Checkout.ThirdPartyCardSurchargePercent = 0;
            YouLi.Trip.Checkout.RefundProtectPercent = 0;
            YouLi.Trip.Checkout.AllowRefundablePayments = false;
            YouLi.Trip.Checkout.CurrencyHasDecimals = true;

            YouLi.Trip.Checkout.IsBalanceSelected = false;
            YouLi.Trip.Checkout.RefundProtectTotalCostEstimate = 0;
            YouLi.Trip.Checkout.RefundProtectOptedOutConfirmed = false;
            YouLi.Trip.Checkout.PrepayTotal = 0;
            YouLi.Trip.Checkout.CouponCodeAmountApplied = 0;
            YouLi.Trip.Checkout.InviteeReferenceCode = "";

            YouLi.Trip.Checkout.SquareApplicationId = '';
            YouLi.Trip.Checkout.SquareLocationId = '';
            YouLi.Trip.Checkout.SquarePaymentForm = null;

            YouLi.Trip.Checkout.PayNowButtonText = "Pay Now";
            YouLi.Trip.Checkout.NotifyPlannerButtonText = "Notify Planner";

            YouLi.Trip.Checkout.SelectedInstallmentId = "";
            YouLi.Trip.Checkout.InstallmentIdBalance = undefined;
            YouLi.Trip.Checkout.InstallmentIdOther = undefined;

            YouLi.Trip.Checkout.EmailDomainValidationWhitelist = [];
            YouLi.Trip.Checkout.EmailDomainValidationErrorText = "";

            YouLi.Trip.Checkout.BookingAddOnOptions = [];
            YouLi.Trip.Checkout.SelectedGangInvoiceAndViewMode = function () {
                if ($('input[type=radio][name="CurrentInvitee.GangInvoiceAndViewMode"]').length > 0) {
                    return $('input[type=radio][name="CurrentInvitee.GangInvoiceAndViewMode"]:checked').val();
                }
                else {
                    return $('input[name="CurrentInvitee.GangInvoiceAndViewMode"]').val();
                }
            }

            YouLi.Trip.Checkout.GetRefundProtectSelection = function () {
                if ($('input[type=radio][name="CurrentInvitee.RefundProtectSelection"]').length > 0) {
                    return $('input[type=radio][name="CurrentInvitee.RefundProtectSelection"]:checked').val();
                }
                else {
                    return $('input[name="CurrentInvitee.RefundProtectSelection"]').val();
                }
            }

            YouLi.Trip.Checkout.InitialiseResponseChecks = function () {

                $(".content-checkout-itinerary-addons .multistate-check-schedule-item-response").multiStateCheck({
                    states: ["unchecked", "checked"],
                    onAfterChangeState: function (e) {

                        YouLi.Common.UI.ShowLoading();

                        const targetElement = e.target;

                        var itemId = $(targetElement).data("id");
                        if ($(targetElement).attr("data-state") == "checked")
                            responseValue = "yes";
                        else
                            var responseValue = "no";

                        YouLi.Trip.Checkout.DoItemResponse(itemId, responseValue, targetElement, function () {

                            // toggle where the cost for addon is shown (depending on whether they are going or not)
                            const targetElementItineraryItemContainer = $(targetElement).closest(".addon-item-container");
                            $(targetElementItineraryItemContainer).find(".cost-label").toggleClass("hidden", responseValue == "yes")
                            $(targetElementItineraryItemContainer).find(".cost-line-item-amount").toggleClass("hidden", responseValue != "yes")

                            YouLi.Common.UI.HideLoading();
                        });
                    }
                })
            };

            YouLi.Trip.Checkout.DoItemResponse = function (itemId, responseValue, element, callback) {

                let targetElement = element;

                let data = {
                    Preview: $("#PreviewMode").val(),
                    ScheduleItemId: itemId,
                    InviteeId: $(element).data("invitee-id"),
                    ResponseValue: responseValue,
                    SelectedTripPackageId: $("#SelectedPackageId").val(),
                    SelectedBookingAddOnOptionId: $("input[type=radio][name=BookingAddOnOption]:checked").val(),
                    gangWithAddOnResponses: GetInviteeDetailsData(),
                    CheckoutFlowNumberInGroup: $("#NumberInGroup").val(),
                };

                data.gangInvoiceAndViewMode = YouLi.Trip.Checkout.SelectedGangInvoiceAndViewMode();

                $.ajax({
                    url: '/trip/checkoutinviteeschedulerespond',
                    type: "POST",
                    dataType: "json",
                    data: JSON.stringify(data),
                    contentType: "application/json; charset=utf-8",
                    complete: function (response) {

                        if (response.responseJSON != undefined && response.responseJSON.url) {
                            YouLi.Common.UI.HideLoading();
                            window.location.href = response.responseJSON.url;
                        }
                        else if (response.status === 500 || (response.responseJSON != undefined && response.responseJSON.success == false)) {
                            YouLi.Common.UI.HideLoading();
                            YouLi.Common.UI.ShowStandardDialog("An error occurred.");

                            // reset the multistate check to the previous value
                            $(targetElement).data("multiStateCheck").revert();
                        }
                        else {

                            var initialSelectedInvoiceAndViewMode = $("input[type=radio][name='CurrentInvitee.GangInvoiceAndViewMode']:checked").val();
                            var initialSelectedPaymentMethod = $("input[type=radio][name=PaymentMethod]:checked").val();
                            var initialSelectedPaymentOption = $("input[type=radio][name=PaymentOption]:checked").val();

                            if (response.responseJSON.isFreePackage) {
                                $(".page-fold-right").addClass("free-package-view");
                            } else {
                                $(".page-fold-right").removeClass("free-package-view");
                            }

                            $(".content-trip-checkout-paymentdetails-costs").html(response.responseJSON.paymentDetailsHtml);

                            YouLi.Trip.Checkout.InitialiseResponseChecks();
                            YouLi.Common.UI.Init();

                            initialiseValidator();

                            if (!initialSelectedPaymentMethod)
                                initialSelectedPaymentMethod = $("input[type=radio][name=PaymentMethod]").first().val();
                            if (!initialSelectedPaymentOption)
                                initialSelectedPaymentOption = $("input[type=radio][name=PaymentOption]").first().val();

                            $("input[type=radio][name='CurrentInvitee.GangInvoiceAndViewMode'][value=" + initialSelectedInvoiceAndViewMode + "]").attr("checked", true);
                            $("input[type=radio][name=PaymentMethod][value=" + initialSelectedPaymentMethod + "]").attr("checked", true);
                            $("input[type=radio][name=PaymentOption][value=" + initialSelectedPaymentOption + "]").attr("checked", true);
                            InitialisePaymentDetails();

                            if (callback) {
                                callback();
                            }
                        }
                    }

                });


            };

            YouLi.Trip.Checkout.UpdateInviteesAndPrice = function (preserveNumberInGroup = false) {

                const defaultPromise = new Promise((resolve, reject) => {
                    resolve('Success!');
                });

                YouLi.Common.UI.ShowLoading();

                let data = {
                    packageId: $("#SelectedPackageId").val(),
                    bookingAddOnOptionId: $("input[type=radio][name=BookingAddOnOption]:checked").val(),
                    tripId: $("#TripId").val(),
                    inviteeId: $("#InviteeId").val(),
                    preview: $("#PreviewMode").val(),
                    gangWithAddOnResponses: GetInviteeDetailsData()
                }

                data.gangInvoiceAndViewMode = YouLi.Trip.Checkout.SelectedGangInvoiceAndViewMode();

                if (preserveNumberInGroup) {
                    data.numberInGroup = $("#NumberInGroup").val();
                }

                return $.ajax({
                    url: "/trip/UpdateCheckoutInviteesAndPrice/",
                    type: "POST",
                    dataType: "json",
                    data: JSON.stringify(data),
                    contentType: "application/json; charset=utf-8",
                    complete: function (response) {
                        YouLi.Common.UI.HideLoading();
                        if (response.responseJSON != undefined && response.responseJSON.url) {
                            window.location.href = response.responseJSON.url;
                        }
                        else if (response.status === 500 || (response.responseJSON != undefined && response.responseJSON.success == false)) {
                            YouLi.Common.UI.ShowStandardDialog("An error occurred. Please refresh the page to try again.");
                        }
                        else {

                            //google analytics
                            PushRemoveCartGAData();
                            $("#GoogleAnalyticsData").html(response.responseJSON.googleAnalyticsHtml);
                            PushAddCartGAData();

                            var initialSelectedInvoiceAndViewMode = $("input[type=radio][name='CurrentInvitee.GangInvoiceAndViewMode']:checked").val();
                            var initialSelectedPaymentMethod = $("input[type=radio][name=PaymentMethod]:checked").val();
                            var initialSelectedPaymentOption = $("input[type=radio][name=PaymentOption]:checked").val();

                            if (response.responseJSON.isFreePackage) {
                                $(".page-fold-right").addClass("free-package-view");
                            } else {
                                $(".page-fold-right").removeClass("free-package-view");
                            }

                            $(".content-trip-checkout-paymentdetails-costs").html(response.responseJSON.paymentDetailsHtml);

                            $(".package-card").html(response.responseJSON.packageCardHtml);
                            $(".gang-setup").html(response.responseJSON.gangSetupHtml);

                            $(".page-fold-right").toggleClass("sold-out-view", !response.responseJSON.packageIsAvailable);
                            $(".page-fold-right").toggleClass("trip-full-view", response.responseJSON.isFull);
                            $(".page-fold-right").toggleClass("trip-full-view", response.responseJSON.wouldOverbook);

                            if (response.responseJSON.packageIsAvailable) {

                                YouLi.Trip.Checkout.InitialiseResponseChecks();

                                initialiseValidator();

                                // initially select the first payment option and payment method
                                if (!initialSelectedPaymentMethod)
                                    initialSelectedPaymentMethod = $("input[type=radio][name=PaymentMethod]").first().val();
                                if (!initialSelectedPaymentOption)
                                    initialSelectedPaymentOption = $("input[type=radio][name=PaymentOption]").first().val();

                                $("input[type=radio][name='CurrentInvitee.GangInvoiceAndViewMode'][value=" + initialSelectedInvoiceAndViewMode + "]").attr("checked", true);
                                $("input[type=radio][name=PaymentMethod][value=" + initialSelectedPaymentMethod + "]").attr("checked", true);
                                $("input[type=radio][name=PaymentOption][value=" + initialSelectedPaymentOption + "]").attr("checked", true);
                                InitialisePaymentDetails();
                            }

                            ClearArrivalDepartureDateEvents();  // clear event handlers for dates which will be re-initialised

                            YouLi.Common.UI.Init();

                            SetupArrivalDepartureDateEvents();

                            InitializeGangEmailEvent();

                            $('.gang-email').trigger('blur');

                            const currentState = $('.gang-member').find('#GangInvitees_0__InviteeCategory').is(':hidden');

                            if (prevState.isPackageCategory) {
                                if (currentState !== prevState.isPackageCategory) {
                                    $('.gang-member').each((index, element) => {
                                        $(element).find(`#GangInvitees_${index}__InviteeCategory`).val(null);
                                    });
                                }
                            }

                            prevState.isPackageCategory = currentState;
                        }
                    }

                });

                return defaultPromise;
            }

            /* Returns a promise */
            YouLi.Trip.Checkout.ProcessGenericCreditCardPayment = function (nonce, paymentMethod) {

                if (nonce) {
                    var $form = $('#PaymentChargeForm');

                    $("#chargeNonce").remove();
                    $form.append($('<input type="hidden" id="chargeNonce" name="chargeNonce">').val(nonce));
                }

                return processCheckout(paymentMethod);
            };

            YouLi.Trip.Checkout.ProcessPaymentWithSavedPaymentMethod = function (isThirdPartyCard) {

                let newPaymentId, couponPaymentId;
                var redirectURL = window.location.href;

                if (YouLi.Trip.Checkout.ConnectedPaymentGateway === YouLi.Common.PaymentGateway.Stripe) {

                    //google tag manager
                    var gaData = YouLi.Common.GetGAData("begin_checkout");
                    dataLayer.push({ ecommerce: null });
                    dataLayer.push(gaData);

                    YouLi.CreditCardPaymentForm.InitialiseStripe()
                        .then(() => YouLi.Trip.Checkout.ProcessGenericCreditCardPayment(undefined, "stripe"))
                        .then((data) => {

                            newPaymentId = data.newPaymentId;
                            couponPaymentId = data.couponPaymentId;

                            if (data.redirectURL) {
                                redirectURL = data.redirectURL;
                            }

                            // 3. Create and Confirm Payment Intent to charge immediately

                            // First, ensure it's actually got a paymentId
                            if (!newPaymentId) {
                                var userMessage = "An error occurred with the payment charge - invalid payment Id";
                                var debugMessage = "Credit Card failure: passed a " + (newPaymentId == null ? "null" : "empty string") + " for paymentId on trip "
                                    + $("#TripId").val() + " for invitee " + $("#InviteeId").val() + " is failing. Domain: " + window.location.host
                                var subject = "Exception occurring - internalPaymentId is being set to an invalid value in Stripe Payment Intent";

                                YouLi.Common.OpenSupportTicket(userMessage, debugMessage, subject);

                                throw new Error(userMessage);
                            }

                            const savedPaymentMethodId = isThirdPartyCard ? $("#ThirdPartyCardPaymentMethodId").val() : $("#SavedPaymentMethodId").val();
                            return YouLi.Trip.Checkout.ChargeStripeSavedPaymentMethod(newPaymentId, redirectURL, isThirdPartyCard, savedPaymentMethodId);
                        })
                        .then((data) => {

                            if (data.redirectURL) {
                                redirectURL = data.redirectURL; // update from the payment intent
                            }

                            if (window.location.href == redirectURL)
                                window.location.reload();
                            else
                                window.location.href = redirectURL;

                        })
                        .catch((errorObject) => {
                            console.error('Error:', errorObject.message);

                            // roll back the payment (and any created coupon payment) that was created locally if a payment was created
                            var paymentsToDelete = [];
                            if (newPaymentId)
                                paymentsToDelete.push(newPaymentId);
                            if (couponPaymentId)
                                paymentsToDelete.push(couponPaymentId);
                            YouLi.CreditCardPaymentForm.CancelInProgressPayment(paymentsToDelete);

                            YouLi.Common.UI.HideLoading();
                            YouLi.Common.UI.HideInputLoading($(".pay-now-button"));

                            if (!errorObject.errorHandled) {
                                YouLi.CreditCardPaymentForm.OnPageErrorHandlerFunction(errorObject.message, moment());
                            }

                        });
                }
                else {
                    console.log("Invalid gateway for saved payment method");
                }

            }

            YouLi.Trip.Checkout.ChargeStripeSavedPaymentMethod = function (paymentId, redirectURL, isThirdPartyCard, savedPaymentMethodId) {

                let data = {
                    tripId: $("#TripId").val(),
                    isCheckoutFlow: true,
                    inviteeReferenceCode: YouLi.Trip.Checkout.InviteeReferenceCode,
                    chargeAmount: $("#ChargeAmount").val(),
                    chargeLabel: $("#ChargeLabel").val(),
                    paymentId: paymentId,
                    isRegisteredWithPayment: false, // never true for Trip Page, only for Checkout
                    useThirdPartyCardPaymentMethod: isThirdPartyCard,
                    thirdPartyCardPaymentCostCentre: $("#ThirdPartyCardPaymentCostCentre").val(),
                    thirdPartyCardPaymentDepartment: $("#ThirdPartyCardPaymentDepartment").val(),
                    thirdPartyCardPaymentApprovedBy: $("#ThirdPartyCardPaymentApprovedBy").val(),
                    savedPaymentMethodId: savedPaymentMethodId,
                    returnURL: redirectURL
                };

                return fetch("/trip/chargestripesavedpaymentmethod", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(data),
                }).then(response => {
                    if (!response.ok) {
                        throw new Error("An error occurred when updating payment intent");
                    }
                    return response.json();
                }).then(data => {

                    if (!data.success) {
                        throw {
                            message: "An error occurred when charging payment",
                            errorHandled: true
                        };
                    }

                    var redirectURL = data.redirectURL;
                    return Promise.resolve({ redirectURL });

                }).catch((error) => {

                    // B. Thulke: I had added this during original dev, but don't see why we would want to do this.  We want them to try again.
                    // if we have an issue with updating the intent, destroy the credit card form
                    //YouLi.CreditCardPaymentForm.StripePaymentElement.destroy();
                    YouLi.Trip.Checkout.ShowErrorOnPage("Error processing payment.  Please try again or contact your planner for assistance", moment());

                    throw {
                        message: "Error charging payment",
                        errorHandled: true
                    };
                });
            }

            YouLi.Trip.Checkout.ShowErrorOnPage = function (errorMessage, errorDate /* a Moment date */) {
                $(".checkout-payment-error").removeClass("hidden");

                if (errorDate)
                    $("#PaymentErrorDate").text(errorDate.format("D MMM YYYY") + " @ " + errorDate.format("h:mma"));

                $("#PaymentErrorMessage").text(errorMessage);

                if ($('#GenericPaymentFormDialog'))
                    $('#GenericPaymentFormDialog').modal('hide');
            };

            var GetInviteeDetailsData = function () {
                var inviteeDetails = [];
                $(".gang-member").each((index, element) => {

                    const inviteeId = $(element).find(`#GangInvitees_${index}__Id`).val();
                    inviteeDetails[index] = {
                        "id": inviteeId,
                        "firstname": $(element).find(`#GangInvitees_${index}__FirstName`).val(),
                        "lastname": $(element).find(`#GangInvitees_${index}__LastName`).val(),
                        "email": $(element).find(`#GangInvitees_${index}__Email`).val(),
                        "phonenumber": $(element).find(`#GangInvitees_${index}__PhoneNumber`).val(),
                        "referencecode": $(element).find(`#GangInvitees_${index}__ReferenceCode`).val(),
                        "arrivaldate": $("#CurrentInvitee_GangInvitees_0__ArrivalDate").val(),   // nb: always using the first gang member's date
                        "departuredate": $("#CurrentInvitee_GangInvitees_0__DepartureDate").val(),   // nb: always using the first gang member's date
                        "optedinaddonids": $(`.multistate-check-schedule-item-response[data-invitee-id=${inviteeId}][data-state=checked]`).map(function () {
                            return $(this).data('id');
                        }).get(),
                        "inviteecategory": $(element).find(`#GangInvitees_${index}__InviteeCategory`).val()
                    }

                    // create an array of profile field data
                    inviteeDetails[index].ProfileFormTaskResponseFields = [];

                    $(element).find(".profile-field").each((fieldIndex, fieldElement) => {
                        inviteeDetails[index].ProfileFormTaskResponseFields[fieldIndex] = {
                            IsSystemField: $(fieldElement).find(`#GangInvitees_${index}__ProfileFormTaskResponseFields_${fieldIndex}__IsSystemField`).val(),
                            IsPrimarySystemField: $(fieldElement).find(`#GangInvitees_${index}__ProfileFormTaskResponseFields_${fieldIndex}__IsPrimarySystemField`).val(),
                            APIFieldName: $(fieldElement).find(`#GangInvitees_${index}__ProfileFormTaskResponseFields_${fieldIndex}__APIFieldName`).val(),
                            FieldType: $(fieldElement).find(`#GangInvitees_${index}__ProfileFormTaskResponseFields_${fieldIndex}__FieldName`).val(),
                            TaskItemFormBuilderFieldId: $(fieldElement).find(`#GangInvitees_${index}__ProfileFormTaskResponseFields_${fieldIndex}__TaskItemFormBuilderFieldId`).val(),
                            IsRequired: $(fieldElement).find(`#GangInvitees_${index}__ProfileFormTaskResponseFields_${fieldIndex}__IsRequired`).val(),
                            Label: $(fieldElement).find(`#GangInvitees_${index}__ProfileFormTaskResponseFields_${fieldIndex}__Label`).val(),
                            ResponseValue: $(fieldElement).find(`#GangInvitees_${index}__ProfileFormTaskResponseFields_${fieldIndex}__ResponseValue`).val(),
                            CustomOptionMultipleAnswers: $(fieldElement).find(`input[name="GangInvitees[${index}].ProfileFormTaskResponseFields[${fieldIndex}].CustomOptionMultipleAnswers"]:checked`)
                                .map(function () {
                                    return $(this).val();
                                }).toArray()
                        }
                    });

                    inviteeDetails[index].ProfileFormTaskResponseFields = inviteeDetails[index].ProfileFormTaskResponseFields.filter(function (field) {
                        return field.IsPrimarySystemField.toLowerCase() === "false";
                    });
                });

                return inviteeDetails;
            };

            YouLi.Trip.Checkout.CancelCheckout = function (paymentIdsToDelete) {

                if (!paymentIdsToDelete || paymentIdsToDelete.length == 0)
                    return Promise.resolve();

                // For checkout, we are going to delete the entire invitee, so just pass the first payment Id

                return fetch(`/trip/cancelinprogresscheckout?tripId=${$("#TripId").val()}&paymentId=${paymentIdsToDelete[0]}`, {
                    method: "GET",
                    headers: {
                        'Cache-Control': 'no-cache'
                    },
                })
            };

            var ChangePaymentOption = function (selectedOption, refreshInstallmentsTable = false) {

                $(".installments-details").addClass("hidden");

                if (selectedOption == "installment") {
                    $(".installments-details").removeClass("hidden");
                }

                // If credit card payemnt form is loaded (it won't be initially for $0 packages)
                if (YouLi.CreditCardPaymentForm) {
                    YouLi.CreditCardPaymentForm.UpdateAutoPayVisibility(selectedOption != "balance");
                }

                // Reset the selected installment value
                if (selectedOption == "installment")
                    YouLi.Trip.Checkout.SelectedInstallmentId = YouLi.Trip.Checkout.InstallmentIdOther;
                else
                    YouLi.Trip.Checkout.SelectedInstallmentId = YouLi.Trip.Checkout.InstallmentIdBalance;

                if (YouLi.Trip.Checkout.SelectedInstallmentId != null) {
                    TogglePaymentButtonVisiblity();

                    // now update the actual payment amount
                    GetSelectedPaymentOptionAmount(refreshInstallmentsTable);
                }
            }

            var ChangeMethodOrOptions = function (selectedMethod) {

                var selectedPaymentMethodElement = $('input[type=radio][name=PaymentMethod]:checked');

                let selectedPaymentOption = $("input[type=radio][name=PaymentOption]:checked").val();

                // hide all and then show whichever is needed
                $(".cost-line-item-credit-card-surcharge").addClass("hidden");
                $(".credit-card-surcharge-val").addClass("hidden");
                $(".cost-line-item-refund-protect").addClass("hidden");
                $(".refund-protect-val").addClass("hidden");
                $("#RefundProtectSelection").addClass("hidden");
                $(".payment-method-details").addClass("hidden");

                $("#ThirdPartyCardDetails").addClass("hidden");
                $("#CustomLinkDetails").addClass("hidden");
                $("#PhoneDetails").addClass("hidden");
                $("#BankTransferDetails").addClass("hidden");

                //// standard labels
                let isPackageSoldout = $(".pay-now-button-label").data('sold-out');
                if (isPackageSoldout) {
                    $(".pay-now-button-label").text("Sold Out");
                } else {
                    $(".pay-now-button-label").text(YouLi.Trip.Checkout.PayNowButtonText);
                }

                switch (selectedMethod) {
                    case "savedpaymentmethod":
                        //$("#PayCreditCard").removeClass("hidden");

                        if (selectedPaymentOption) {
                            if (YouLi.PaymentChargeForm.Default.SurchargePercent > 0 && YouLi.PaymentChargeForm.Ach.HasSurcharge === false) {
                                $(".cost-line-item-credit-card-surcharge").removeClass("hidden");
                                // show the surcharge value associated with this selected payement method
                                selectedPaymentMethodElement.closest(".row").find(".credit-card-surcharge-val").removeClass("hidden");
                            }
                        }
                        break;
                    case "thirdpartycard":
                        if (selectedPaymentOption) {
                            if (YouLi.Trip.Checkout.ThirdPartyCardSurchargePercent > 0) {
                                $(".cost-line-item-credit-card-surcharge").removeClass("hidden");
                                // show the surcharge value associated with this selected payement method
                                selectedPaymentMethodElement.closest(".row").find(".credit-card-surcharge-val").removeClass("hidden");
                            }
                        }
                        $("#ThirdPartyCardDetails").removeClass("hidden");
                        break;
                    case "creditcard":
                        $("#PayCreditCard").removeClass("hidden");

                        if (selectedPaymentOption) {
                            if (YouLi.PaymentChargeForm.Default.SurchargePercent > 0 && YouLi.PaymentChargeForm.Ach.HasSurcharge === false) {
                                $(".cost-line-item-credit-card-surcharge").removeClass("hidden");
                                // show the surcharge value associated with this selected payement method
                                selectedPaymentMethodElement.closest(".row").find(".credit-card-surcharge-val").removeClass("hidden");
                            }
                        }
                        break;
                    case "banktransfer":
                        $("#PayBankTransfer").removeClass("hidden");
                        $("#BankTransferDetails").removeClass("hidden");
                        // override some labels
                        if (isPackageSoldout) {
                            $(".pay-now-button-label").text("Sold Out");
                        } else {
                            $(".pay-now-button-label").text(YouLi.Trip.Checkout.NotifyPlannerButtonText);
                        }
                        break;
                    case "paypallink":
                        $("#PayPayPalLink").removeClass("hidden");
                        break;
                    case "phone":
                        $("#PayPhone").removeClass("hidden");
                        $("#PhoneDetails").removeClass("hidden");
                        if (isPackageSoldout) {
                            $(".pay-now-button-label").text('Sold Out');
                        } else {
                            var isMobile = navigator.userAgent.match(/(iPhone|iPod|iPad|Android|webOS|BlackBerry|IEMobile|Opera Mini)/i);
                            $(".pay-now-button-label").text(isMobile ? YouLi.Trip.Checkout.PayNowButtonText : YouLi.Trip.Checkout.NotifyPlannerButtonText);
                        }

                        break;
                    case "customlink":
                        $("#CustomLinkDetails").removeClass("hidden");
                        break;
                }

                ToggleRefundProtectVisiblity();

                TogglePaymentButtonVisiblity();

                // update the charge details if they have selected a method - we have to redo this here because of method-based surcharges
                if (selectedMethod)
                    UpdateChargeDetails(undefined);
            };

            var ToggleRefundProtectVisiblity = function () {
                let selectedPaymentOption = $("input[type=radio][name=PaymentOption]:checked").val();
                var selectedPaymentMethod = $('input[type=radio][name=PaymentMethod]:checked').val();

                if (selectedPaymentMethod) {
                    if (selectedPaymentOption) {
                        $(".cost-line-item-refund-protect").removeClass("hidden");
                        $(".refund-protect-val").removeClass("hidden");
                    }

                    if (YouLi.Trip.Checkout.RefundProtectPercent > 0) {
                        $("#RefundProtectSelection").removeClass("hidden");
                    }
                }

            }

            var TogglePaymentButtonVisiblity = function () {
                let selectedPaymentOption = $("input[type=radio][name=PaymentOption]:checked").val();
                var selectedPaymentMethod = $('input[type=radio][name=PaymentMethod]:checked').val();

                $(".payment-button").toggleClass("hidden", !(selectedPaymentMethod && selectedPaymentOption)); // only show if a method AND the payment option have both been selected
            }

            var UpdateChargeLabelFromPrimaryInvitee = function () {

                let label = $("input[Name=ChargeLabel]").val();

                label = label.replace("[NAME]", `${$("#GangInvitees_0__FirstName").val()} ${$("#GangInvitees_0__LastName").val()}`);

                $("input[Name=ChargeLabel]").val(label);
            }

            var UpdateBillToEmailFromPrimaryInvitee = function () {

                let billToEmail = $("input[Name=billtoemail]");

                if (billToEmail.length > 0) {
                    billToEmail.val($("#GangInvitees_0__Email").val());
                    billToEmail.prop("readOnly", billToEmail.val().length > 0)
                }
            }

            var UpdateTotalAmountDue = function () {
                $("input[Name=ChargeAmount]").val(YouLi.PaymentChargeForm.GetChargeAmount());
            }

            var GetSelectedBookingAddOnOption = function () {
                let selectedBookingAddOnOptionId = $('input[type=radio][name=BookingAddOnOption]:checked').val();

                if (YouLi.Trip.Checkout.BookingAddOnOptions.length == 0)
                    return undefined;

                return YouLi.Trip.Checkout.BookingAddOnOptions.find((item) => {
                    return item.Id == selectedBookingAddOnOptionId;
                });
            };

            var GetBookingAddOnOptionTotalPriceDue = function () {
                let result = 0;

                if (YouLi.Trip.Checkout.BookingAddOnOptions.length > 0 && $('input[type=radio][name=BookingAddOnOption]').length > 0) {
                    const selectedBookingAddOnOption = GetSelectedBookingAddOnOption();

                    const numTravellersMultiplier = $("#SelectedTripPackageNumTravellers").val() > 1 ? $("#SelectedTripPackageNumTravellers").val() : 1;

                    const numberInGroup = $("#NumberInGroup").length > 0 ? $("#NumberInGroup").val() : 1;

                    if (YouLi.Trip.Checkout.SelectedGangInvoiceAndViewMode() == "paytogether")
                        result = selectedBookingAddOnOption.PricePerPerson * numberInGroup * numTravellersMultiplier;
                    else
                        result = selectedBookingAddOnOption.PricePerPerson * numTravellersMultiplier;
                }

                return result;
            };

            var GetBookingAddOnOptionTotalPriceForGang = function () {
                let result = 0;

                if (YouLi.Trip.Checkout.BookingAddOnOptions.length > 0 && $('input[type=radio][name=BookingAddOnOption]').length > 0) {
                    const selectedBookingAddOnOption = GetSelectedBookingAddOnOption();

                    const numTravellersMultiplier = $("#SelectedTripPackageNumTravellers").val() > 1 ? $("#SelectedTripPackageNumTravellers").val() : 1;

                    const numberInGroup = $("#NumberInGroup").length > 0 ? $("#NumberInGroup").val() : 1;

                    result = selectedBookingAddOnOption.PricePerPerson * numberInGroup * numTravellersMultiplier;
                }

                return result;
            };

            var UpdateChargeDetails = function (label) {

                /// Add surcharge and any other charges to the amount before setting
                let selectedPaymentOption = $("input[type=radio][name=PaymentOption]:checked").val();
                let selectedPaymentMethod = $('input[type=radio][name=PaymentMethod]:checked').val();

                YouLi.PaymentChargeForm.BookingAddOnAmountDue = GetBookingAddOnOptionTotalPriceDue();

                if (YouLi.Trip.Checkout.BookingAddOnOptions.length > 0 && $('input[type=radio][name=BookingAddOnOption]').length > 0) {
                    const selectedBookingAddOnOption = GetSelectedBookingAddOnOption();

                    $("#TripBookingAddonOptionConsentText").html(selectedBookingAddOnOption.ConsentPrompt);
                }

                let surchargeAmount = 0;
                let totalAmountDue = 0;

                if (selectedPaymentMethod === "thirdpartycard") {
                    surchargeAmount = parseFloat(((YouLi.PaymentChargeForm.AmountDue + YouLi.PaymentChargeForm.BookingAddOnAmountDue) * YouLi.Trip.Checkout.ThirdPartyCardSurchargePercent / 100).toFixed(2));
                    $(".credit-card-surcharge-val").html(`${YouLi.PaymentChargeForm.GetFormattedCurrency(surchargeAmount)}`);
                    $(".cost-line-item-surcharge-val").html(`${YouLi.PaymentChargeForm.GetFormattedCurrency(surchargeAmount)}`);

                    if (selectedPaymentOption
                        && YouLi.Trip.Checkout.ThirdPartyCardSurchargePercent > 0) {
                        $(".cost-line-item-credit-card-surcharge").removeClass("hidden");
                        $(".cost-line-item-surcharge-val").removeClass("hidden");
                    }
                }
                else if (selectedPaymentMethod === "creditcard") {
                    surchargeAmount = parseFloat(YouLi.PaymentChargeForm.GetSurchargeAmount(null).toFixed(2));
                    $(".credit-card-surcharge-val").html(`${YouLi.PaymentChargeForm.GetFormattedCurrency(surchargeAmount)}`);
                    $(".cost-line-item-surcharge-val").html(`${YouLi.PaymentChargeForm.GetFormattedCurrency(surchargeAmount)}`);

                    if (selectedPaymentOption
                        && YouLi.PaymentChargeForm.Default.SurchargePercent > 0
                        && YouLi.PaymentChargeForm.Ach.HasSurcharge === false) {
                        $(".cost-line-item-credit-card-surcharge").removeClass("hidden");
                        $(".cost-line-item-surcharge-val").removeClass("hidden");
                    }

                }
                totalAmountDue = YouLi.PaymentChargeForm.AmountDue + YouLi.PaymentChargeForm.BookingAddOnAmountDue + surchargeAmount;

                var tripTotal = YouLi.Trip.Checkout.PrepayTotal - YouLi.Trip.Checkout.CouponCodeAmountApplied;

                // add Refund Protect (if applicable and selected)
                $(".cost-line-item-refund-protect").addClass("hidden");
                $(".refund-protect-val").addClass("hidden");
                let refundProtectAmount = 0;
                let refundPercentage = 0;
                if (YouLi.Trip.Checkout.RefundProtectPercent > 0
                    && selectedPaymentOption
                    && $("input[type=radio][name='CurrentInvitee.RefundProtectSelection']:checked").val() != undefined
                    && $("input[type=radio][name='CurrentInvitee.RefundProtectSelection']:checked").val().toLowerCase() == "optedin"
                ) {

                    refundProtectAmount = parseFloat((totalAmountDue * YouLi.Trip.Checkout.RefundProtectPercent / 100).toFixed(2));
                    refundPercentage = YouLi.Trip.Checkout.RefundProtectPercent;
                    $(".refund-protect-val").html(`${YouLi.PaymentChargeForm.GetFormattedCurrency(refundProtectAmount)}`);

                    $(".cost-line-item-refund-protect").removeClass("hidden");
                    $(".refund-protect-val").removeClass("hidden");

                    if (!YouLi.Trip.Checkout.AllowRefundablePayments)
                        tripTotal += YouLi.Trip.Checkout.RefundProtectTotalCostEstimate;
                }
                else {
                    $(".cost-line-item-refund-protect").addClass("hidden");
                    $(".refund-protect-val").addClass("hidden");
                }

                // Update booking add-on if in use
                if ($(".cost-line-item-amount-booking-add-on-total").length > 0) {

                    $(".booking-add-on-val").html(`${YouLi.PaymentChargeForm.GetFormattedCurrency(YouLi.PaymentChargeForm.BookingAddOnAmountDue)}`);

                    const bookingAddOnOptionTotalPriceForGang = GetBookingAddOnOptionTotalPriceForGang();
                    $(".cost-line-item-amount-booking-add-on-total").html(`${YouLi.PaymentChargeForm.GetFormattedCurrency(bookingAddOnOptionTotalPriceForGang)}`);
                }

                // update the trip total to include any extras (e.g. RP and booking add-on)
                $(".cost-line-item-amount-total").html(`${YouLi.PaymentChargeForm.GetFormattedCurrency(tripTotal)}`);

                $(".cost-line-item-installment-total").html(YouLi.PaymentChargeForm.GetFormattedCurrency(YouLi.PaymentChargeForm.AmountDue));

                $(".cost-line-item-amount-due").html(YouLi.PaymentChargeForm.GetFormattedCurrency(YouLi.PaymentChargeForm.AmountDue));

                YouLi.PaymentChargeForm.UpdatePaymentInfo({
                    surchargeAmount: surchargeAmount,
                    refundProtectAmount: refundProtectAmount,
                    refundProtectPercent: refundPercentage
                });

                if (selectedPaymentMethod === "creditcard" && YouLi.PaymentChargeForm.Ach.HasSurcharge === true) {
                    $(".cost-line-item-amount-payment-total").html(YouLi.PaymentChargeForm.GetFormattedCurrency(YouLi.PaymentChargeForm.GetChargeAmountNoSurcharge()));
                    $('#GenericPaymentFormDialog')
                        .find('.cost-line-item-amount-payment-total')
                        .html(YouLi.PaymentChargeForm.GetFormattedCurrency(YouLi.PaymentChargeForm.GetChargeAmount()));
                } else {
                    $(".cost-line-item-amount-payment-total").html(YouLi.PaymentChargeForm.GetFormattedCurrency(YouLi.PaymentChargeForm.GetChargeAmount()));
                }

                $("input[Name=RefundProtectAmount]").val(refundProtectAmount);
                UpdateTotalAmountDue();
                $("input[Name=SurchargeAmount]").val(surchargeAmount);

                if (label) {
                    $("input[Name=ChargeLabel]").val(label);
                }

                // trigger the change event on the ChargeAmount field for things like updating the payment intent for Stripe
                $("input[Name=ChargeAmount]").trigger("change");
            };

            var GetSelectedPaymentOptionAmount = function (refreshInstallmentsTable) {
                YouLi.Common.UI.ShowLoading();

                let data = {
                    preview: $("#PreviewMode").val(),
                    costInstallmentId: YouLi.Trip.Checkout.SelectedInstallmentId,
                    tripId: $("#TripId").val(),
                    inviteeId: $("#InviteeId").val(),
                    couponCode: $("#ChargeCouponCode").val(),
                    selectedTripPackageId: $("#SelectedPackageId").val(),
                    selectedBookingAddOnOptionId: $("input[type=radio][name=BookingAddOnOption]:checked").val(),
                    checkoutFlow: true,
                    checkoutFlowNumberInGroup: $("#NumberInGroup").val(),
                    gangWithAddOnResponses: GetInviteeDetailsData(),
                    refreshInstallmentsTable: refreshInstallmentsTable
                }

                data.gangInvoiceAndViewMode = YouLi.Trip.Checkout.SelectedGangInvoiceAndViewMode();

                $.ajax({
                    url: `/trip/getinstallmentamount`,
                    type: "POST",
                    dataType: "json",
                    data: JSON.stringify(data),
                    contentType: "application/json; charset=utf-8",
                    complete: function (response) {
                        YouLi.Common.UI.HideLoading();
                        if (response.responseJSON != undefined && response.responseJSON.url) {
                            window.location.href = response.responseJSON.url;
                        }
                        else if (response.status === 500 || (response.responseJSON != undefined && response.responseJSON.success == false)) {
                            YouLi.Common.UI.ShowStandardDialog("An error occurred. Please refresh the page to try again.");
                        }
                        else {
                            YouLi.Trip.Checkout.IsBalanceSelected = response.responseJSON.installmentIsBalance;
                            YouLi.PaymentChargeForm.AmountDue = response.responseJSON.installmentAmountDue;

                            // For balance, we need to remove the upfront amount from the amount due before using it.  We then add it as needed along the way
                            if (YouLi.Trip.Checkout.IsBalanceSelected) {
                                const bookingAddOnOptionTotalPrice = GetBookingAddOnOptionTotalPriceDue();
                                YouLi.PaymentChargeForm.AmountDue -= bookingAddOnOptionTotalPrice;
                            }

                            if (YouLi.Trip.Checkout.SelectedGangInvoiceAndViewMode() == "paytogether") {
                                $(".cost-line-item-text-installment-label").html(response.responseJSON.installmentLabel);
                                $(".cost-line-item-total-invitee").addClass("hidden");
                            }
                            else {
                                $(".cost-line-item-text-installment-label").html(`Your ${response.responseJSON.installmentLabel}`);
                                $(".cost-line-item-total-invitee").removeClass("hidden");
                                $(".cost-line-item-amount-total-invitee").html(YouLi.PaymentChargeForm.GetFormattedCurrency(response.responseJSON.paySeparatelyInviteePrepayTotal));
                            }

                            if (response.responseJSON.newInstallmentsTableHtml && $(".cost-installments-selection").length > 0) {
                                $(".cost-installments-selection").html(response.responseJSON.newInstallmentsTableHtml);
                            }

                            UpdateChargeDetails(response.responseJSON.chargeLabel);

                            $("input[Name=ChargeInstallmentId]").val(YouLi.Trip.Checkout.SelectedInstallmentId);
                        }
                    }
                });
            };

            var InitialisePaymentDetails = function () {

                ChangePaymentOption($("input[type=radio][name=PaymentOption]:checked").val());
                ChangeMethodOrOptions($("input[type=radio][name=PaymentMethod]:checked").val(), true);
            }

            var ScrollToInvalid = function () {
                var errorElements = document.querySelectorAll(".has-error");

                if (errorElements.length == 0)
                    return;

                $('html, body').animate({
                    scrollTop: $(errorElements[0]).focus().offset().top - 80
                }, 1000);
            }

            var hasBillingAddress = function () {
                return $("#BillToFieldsIncluded") && $("#BillToFieldsIncluded").val() == "true";
            }

            var continuePayment = function () {

                YouLi.Common.UI.ShowInputLoading($(".pay-now-button"));

                UpdateChargeLabelFromPrimaryInvitee();
                UpdateBillToEmailFromPrimaryInvitee();
                UpdateChargeDetails(undefined);
                var selectedPaymentMethod = $('input[type=radio][name=PaymentMethod]:checked').val();

                switch (selectedPaymentMethod) {
                    case "thirdpartycard":

                        if (!$("#PaymentCostChargingDetailsForm").valid()) {
                            ScrollToInvalid();
                            YouLi.Common.UI.HideInputLoading($(".pay-now-button"));
                            return;
                        }

                        $("#SavedThirdPartyCardConfirmationDialog .current-payment-amount").text(
                            YouLi.PaymentChargeForm.GetFormattedCurrency(YouLi.PaymentChargeForm.GetChargeAmount()));

                        $("#SavedThirdPartyCardConfirmationDialog").modal("show");

                        break;
                    case "creditcard":

                        YouLi.Common.UI.ShowLoading();

                        //google tag manager
                        var gaData = YouLi.Common.GetGAData("begin_checkout");
                        dataLayer.push({ ecommerce: null });
                        dataLayer.push(gaData);

                        if (YouLi.Trip.Checkout.ConnectedPaymentGateway === YouLi.Trip.Checkout.PaymentGateway.Stripe) {
                            YouLi.CreditCardPaymentForm.InitialiseStripe()
                                .then(() => {
                                    YouLi.Common.UI.HideLoading();

                                    YouLi.CreditCardPaymentForm.IsRegisteredWithPayment = true;
                                    $('#GenericPaymentFormDialog').modal('show');
                                })
                        }
                        else {
                            YouLi.Common.UI.HideLoading();
                            $('#GenericPaymentFormDialog').modal('show');
                        }

                        YouLi.Common.UI.HideInputLoading($(".pay-now-button"));

                        break;
                    case "banktransfer":
                    case "paypallink":
                    case "phone":
                    case "customlink":
                        YouLi.Common.UI.ShowLoading();

                        processCheckout(selectedPaymentMethod)
                            .then(() => {
                                YouLi.Common.UI.HideLoading();
                            }).catch((errorObject) => {
                                console.error('Error:', errorObject.message);

                                YouLi.Common.UI.HideLoading();
                            });
                        break;
                }
            };

            /* Returns a promise */
            var processCheckout = function (paymentMethod) {

                $(".checkout-payment-error").addClass("hidden");

                let data = {
                    preselectedFreeTextRoom: $("#PreselectedFreeTextRoom").val(),
                    gangName: $("#GangName").val(),
                    gangWithAddOnResponses: GetInviteeDetailsData(),
                    paymentMethod: paymentMethod,
                    checkoutPrefillId: $("#CheckoutPrefillId").val()
                };

                if (paymentMethod === "stripe") {
                    const pmType = YouLi.CreditCardPaymentForm.SelectedPaymentMethodType;
                    if (pmType) {
                        data.paymentMethodType = pmType;
                    }

                    const isIntentionToEnrolInAutoPay = $("#GenericPaymentFormDialog #EnrolInAutoPay").is(":checked");
                    if (isIntentionToEnrolInAutoPay) {
                        data.isIntentionToEnrolInAutoPay = true;
                    }
                }

                data["gangInvoiceAndViewMode"] = YouLi.Trip.Checkout.SelectedGangInvoiceAndViewMode();

                var paymentChargeFormData = new FormData($("#PaymentChargeForm")[0]);
                for (let pair of paymentChargeFormData.entries()) {
                    data[pair[0]] = pair[1];    // add the form field data
                }

                data["isRegisteredWithPayment"] = true; // always true for checkout page

                if (YouLi.Trip.Checkout.RefundProtectOptedOutConfirmed)
                    data["optedOutRefundProtect"] = true;

                data["RefundProtectSelection"] = YouLi.Trip.Checkout.GetRefundProtectSelection();

                data["includedBillingAddress"] = hasBillingAddress();
                if (hasBillingAddress()) {
                    // add credit card form details like billing details
                    var creditCardFormData = new FormData($('#GenericPaymentForm')[0]);
                    for (let pair of creditCardFormData.entries()) {
                        data[pair[0]] = pair[1];
                    }
                }

                if ($('input[type=radio][name=PaymentMethod]:checked').val() === "thirdpartycard") {
                    data["IsThirdPartyCardPayment"] = true;
                    data["ThirdPartyCardPaymentMethodId"] = $("#ThirdPartyCardPaymentMethodId").val();
                    data["ThirdPartyCardPaymentCostCentre"] = $("#ThirdPartyCardPaymentCostCentre").val();
                    data["ThirdPartyCardPaymentDepartment"] = $("#ThirdPartyCardPaymentDepartment").val();
                    data["ThirdPartyCardPaymentApprovedBy"] = $("#ThirdPartyCardPaymentApprovedBy").val();
                }

                // For payment methods that use the Generic Credit Card popup,
                // hide the modal - do this after we've grabbed out the form data
                if ($("#GenericPaymentFormDialog").hasClass("in"))
                    YouLi.Common.UI.ShowButtonLoading($("#p-creditcard"));

                return new Promise((resolve, reject) => {
                    $.ajax({
                        url: '/trip/checkoutinviteerespond/',
                        type: "POST",
                        dataType: "json",
                        data: JSON.stringify(data),
                        contentType: "application/json; charset=utf-8",
                        complete: function (response) {
                            if (response.status === 500) {
                                if ($("#GenericPaymentFormDialog").hasClass("in")) {
                                    YouLi.Common.UI.HideButtonLoading($("#p-creditcard"));
                                    $("#GenericPaymentFormDialog").modal("hide");
                                }

                                YouLi.Common.UI.HideInputLoading($(".pay-now-button"));

                                $(".checkout-payment-error").removeClass("hidden");

                                $(".payment-error-message").text("");

                                return reject({
                                    message: "checkoutinviteerespond failed",
                                    errorHandled: true
                                });
                            }
                            else if (response.responseJSON.statusCode === 500 || response.status === 500 || (response.responseJSON != undefined && response.responseJSON.success == false)) {
                                if ($("#GenericPaymentFormDialog").hasClass("in")) {
                                    YouLi.Common.UI.HideButtonLoading($("#p-creditcard"));
                                    $("#GenericPaymentFormDialog").modal("hide");
                                }

                                YouLi.Common.UI.HideInputLoading($(".pay-now-button"));

                                let errorMessages = [];
                                $.each(response.responseJSON.errors, function () {
                                    errorMessages.push(this[this.length - 1].ErrorMessage);
                                });

                                $(".payment-error-message").text(errorMessages.join(", "));

                                if (paymentMethod === 'paypal') {
                                    $('.checkout-payment-paypal-error').removeClass('hidden');
                                    $('html, body').animate({
                                        scrollTop: $('.checkout-payment-paypal-error').offset().top - 80
                                    }, 1000);

                                } else {
                                    $('.checkout-payment-error').removeClass('hidden');
                                    $('html, body').animate({
                                        scrollTop: $('.checkout-payment-error').offset().top - 80
                                    }, 1000);

                                }

                                return reject({
                                    message: "checkoutinviteerespond failed",
                                    errorHandled: true
                                });
                            }
                            else {
                                YouLi.Common.UI.ClearClientSideErrors();

                                if (YouLi.Common.GetGAData != null) {
                                    var gaData = YouLi.Common.GetGAData("purchase");
                                    dataLayer.push({ ecommerce: null });
                                    dataLayer.push(gaData);
                                }

                                if (response.responseJSON.url) {
                                    window.location.href = response.responseJSON.url;
                                    if (response.responseJSON.reload)
                                        location.reload();
                                } else {
                                    // return the new payment ID (for things like Stripe)
                                    const newPaymentId = response.responseJSON.newPaymentId;
                                    const redirectURL = response.responseJSON.tripPageRedirectURI;
                                    return resolve({ newPaymentId, redirectURL });
                                }
                            }
                        }
                    });
                });
            };

            var PushRemoveCartGAData = function () {
                //remove_from_cart event
                var removeFromCartData = YouLi.Common.GetGAData("remove_from_cart");
                dataLayer.push({ ecommerce: null });
                dataLayer.push(removeFromCartData);
            }

            var PushAddCartGAData = function () {
                //add_to_cart
                var removeFromCartData = YouLi.Common.GetGAData("add_to_cart");
                dataLayer.push({ ecommerce: null });
                dataLayer.push(removeFromCartData);
            }

            var ClearArrivalDepartureDateEvents = function () {
                $(document).off("dp.change", "#CurrentInvitee_GangInvitees_0__ArrivalDate");
                $(document).off("dp.change", "#CurrentInvitee_GangInvitees_0__DepartureDate");
            };

            var SetupArrivalDepartureDateEvents = function () {
                $(document).off("dp.change", "#CurrentInvitee_GangInvitees_0__ArrivalDate");
                $(document).on("dp.change", "#CurrentInvitee_GangInvitees_0__ArrivalDate", function () {
                    YouLi.Trip.Checkout.UpdateInviteesAndPrice(true);
                });

                $(document).off("dp.change", "#CurrentInvitee_GangInvitees_0__DepartureDate");
                $(document).on("dp.change", "#CurrentInvitee_GangInvitees_0__DepartureDate", function () {
                    YouLi.Trip.Checkout.UpdateInviteesAndPrice(true);
                });
            };

            const InitializeGangEmailEvent = function () {

                $(document).off('blur', '.gang-email');
                $(document).on('blur', '.gang-email', function (e) {
                    const elem = $(this);
                    const newValue = elem.val();
                    const oldValue = elem.data('old-value');

                    if (oldValue === newValue || newValue === '') {
                        return;
                    }

                    const param = {
                        tripId: $("#TripId").val(),
                        email: newValue
                    }

                    YouLi.Common.Get(
                        '/trip/GetTripInviteeIsBooked',
                        param,
                        function (response) {
                            elem.siblings('.email-paid-warning').toggle(response);
                            elem.attr('data-old-value', newValue);
                        }
                    );
                });
            }

            const initialiseValidator = function () {

                $.validator.unobtrusive.parse($("#GangSetupForm"));
                $.validator.unobtrusive.parse($("#TripConsentForm"));

                if ($("#RefundProtectConfirmationForm").length > 0)
                    $.validator.unobtrusive.parse("#RefundProtectConfirmationForm")

                // setup email validation if required
                if (YouLi.Trip.Checkout.EmailDomainValidationWhitelist.length > 0) {

                    $.validator.addMethod("emailDomainValid", function (value, element) {
                        if (!value) return true;

                        var emailDomain = value.split('@')[1];

                        return YouLi.Trip.Checkout.EmailDomainValidationWhitelist.includes(emailDomain);

                    }, YouLi.Trip.Checkout.EmailDomainValidationErrorText);

                    // for each element with class "gang-email"
                    $('.gang-email').each(function () {

                        $(this).rules("add", {
                            emailDomainValid: true
                        });
                    });
                }

                YouLi.Validation.Init();
            }

            $(function () {

                initialiseValidator();
                
                $(document).off("click");
                $(document).on("click", ".go-back-link", function () {
                    if (history.length > 1)
                        history.back();
                    else
                        window.location.href = $(this).data("logo-link");
                });

                $(document).off("change", "#SelectedPackageId");
                $(document).on("change", "#SelectedPackageId", function () {
                    $('.gang-member').each((index, element) => {
                        $(element).find(`#GangInvitees_${index}__InviteeCategory`).val(null);
                    });
                    YouLi.Trip.Checkout.UpdateInviteesAndPrice();
                });

                $(document).off("change", "#NumberInGroup");
                $(document).on("change", "#NumberInGroup", function () {
                    YouLi.Trip.Checkout.UpdateInviteesAndPrice(true);
                });

                $(document).off("change", ".gang-category");
                $(document).on("change", ".gang-category", function () {
                    YouLi.Trip.Checkout.UpdateInviteesAndPrice(true);
                });

                SetupArrivalDepartureDateEvents();

                $(document).off("click", ".choose-default-package");
                $(document).on("click", ".choose-default-package", function () {
                    $("#SelectedPackageId").prop("selectedIndex", 0).change();
                });

                $(document).off("click", ".choose-free-package");
                $(document).on("click", ".choose-free-package", function () {
                    //$("#SelectedPackageId").prop("selectedIndex", 0).change();

                    var gangFormIsValid = $('#GangSetupForm').valid();

                    var tripConsentFormIsValid = true;
                    if ($("#TripConsentForm").length > 0)
                        tripConsentFormIsValid = $("#TripConsentForm").valid();

                    if (!(gangFormIsValid && tripConsentFormIsValid)) {
                        ScrollToInvalid();
                        return;
                    }

                    YouLi.Common.UI.ShowButtonLoading($(".choose-free-package"));

                    processCheckout(null).then(() => {
                        YouLi.Common.UI.HideButtonLoading($(".choose-free-package"));
                    }).catch((errorObject) => {
                        console.error('Error:', errorObject.message);

                        YouLi.Common.UI.HideButtonLoading($(".choose-free-package"));
                    });
                });

                $(document).off("change", "input[type=radio][name=BookingAddOnOption]");
                $(document).on("change", "input[type=radio][name=BookingAddOnOption]", function () {

                    YouLi.Trip.Checkout.UpdateInviteesAndPrice(true);
                });

                // initially select the first payment option and payment method
                // YOULI-8514 remove initial server call
                //$("input[type=radio][name=PaymentOption]").first().prop("checked", true);
                //$("input[type=radio][name=PaymentMethod]").first().prop("checked", true);

                $(document).off("change", "input[type=radio][name=PaymentOption]")
                $(document).on("change", "input[type=radio][name=PaymentOption]", function () {
                    var selectedOption = $(this).val();

                    ChangePaymentOption(selectedOption);
                });

                $(document).off("change", "input[type=radio][name=PaymentMethod]");
                $(document).on("change", "input[type=radio][name=PaymentMethod]", function () {
                    var selectedMethod = $(this).val();

                    ChangeMethodOrOptions(selectedMethod, false, true);

                });

                $(document).off("change", "input[type=radio][name='CurrentInvitee.GangInvoiceAndViewMode']")
                $(document).on("change", "input[type=radio][name='CurrentInvitee.GangInvoiceAndViewMode']", function () {
                    // trigger change method, but it will just be for updating (same as for refund protect, below)
                    var selectedOption = $('input[type=radio][name=PaymentOption]:checked').val();
                    ChangePaymentOption(selectedOption, /* refreshInstallmentsTable = */true);
                });

                $(document).off("change", "input[type=radio][name='CurrentInvitee.RefundProtectSelection']");
                $(document).on("change", "input[type=radio][name='CurrentInvitee.RefundProtectSelection']", function () {

                    // trigger change method, but it will just be for updating refund protect
                    var selectedPaymentMethod = $('input[type=radio][name=PaymentMethod]:checked').val();
                    ChangeMethodOrOptions(selectedPaymentMethod, true, true); // Nb: no scroll when changing Refund Protect

                });

                $(document).off("click", ".show-itinerary-details-link");
                $(document).on("click", ".show-itinerary-details-link", function () {
                    ShowItemDetails($(this).closest(".addon-item-container"));

                    $("#ProgramItemDialog").modal("show");
                });


                // If credit card payemnt form is loaded (it won't be initially for $0 packages)
                if (YouLi.CreditCardPaymentForm) {
                    var selectedOption = $('input[type=radio][name=PaymentOption]:checked').val();
                    YouLi.CreditCardPaymentForm.UpdateAutoPayVisibility(selectedOption != "balance");
                }
                ShowItemDetails = function (gridItemElement) {
                    $(gridItemElement).find(".addon-item-details-contents").clone().appendTo($("#ProgramItemDialog .modal-body").empty()).find(".show-more").remove();
                    $currentlySelectedItem = $(gridItemElement);
                }

                let isPackageSoldout = $(".choose-default-package").data('sold-out');
                if (!isPackageSoldout) {

                    //InitialisePaymentDetails();

                    YouLi.Trip.Checkout.InitialiseResponseChecks();
                }

                $(document).off("click", "#SavedThirdPartyCardConfirmationOk");
                $(document).on("click", "#SavedThirdPartyCardConfirmationOk", function () {

                    $("#SavedThirdPartyCardConfirmationDialog").modal("hide");

                    YouLi.Trip.Checkout.ProcessPaymentWithSavedPaymentMethod(true);
                });

                $(document).off("click", "#SavedThirdPartyCardConfirmationCancel");
                $(document).on("click", "#SavedThirdPartyCardConfirmationCancel", function () {
                    YouLi.Common.UI.HideInputLoading($(".pay-now-button"));
                });



                $(document).on("click", ".apply-coupon-code", function () {

                    $(".content-trip-coupon-code-error").addClass("hidden");
                    YouLi.Common.UI.ShowLoading();

                    let selectedCouponCode = $("#SelectedCouponCode").val();

                    let data = {
                        couponCode: selectedCouponCode,
                        preview: $("#PreviewMode").val(),
                        tripId: $("#TripId").val(),
                        inviteeId: $("#InviteeId").val(),
                        installmentId: YouLi.Trip.Checkout.SelectedInstallmentId,
                        selectedTripPackageId: $("#SelectedPackageId").val(),
                        selectedBookingAddOnOptionId: $("input[type=radio][name=BookingAddOnOption]:checked").val(),
                        checkoutFlow: true,
                        checkoutFlowNumberInGroup: $("#NumberInGroup").val(),
                        gangWithAddOnResponses: GetInviteeDetailsData()
                    };

                    data.gangInvoiceAndViewMode = YouLi.Trip.Checkout.SelectedGangInvoiceAndViewMode();

                    $.ajax({
                        url: '/trip/applycouponcode/',
                        type: "POST",
                        dataType: "json",
                        data: JSON.stringify(data),
                        contentType: "application/json; charset=utf-8",
                        complete: function (response) {
                            YouLi.Common.UI.HideLoading();
                            if (response.responseJSON != undefined && response.responseJSON.url) {
                                window.location.href = response.responseJSON.url;
                            }
                            else if (response.status === 500 || (response.responseJSON != undefined && response.responseJSON.success == false)) {
                                YouLi.Common.UI.ShowStandardDialog("An error occurred. Please refresh the page to try again.");
                            }
                            else if (response.responseJSON.errorMessage) {
                                $(".content-trip-coupon-code-error").removeClass("hidden")
                                $("#CouponCodeErrorMessage").text(response.responseJSON.errorMessage);
                            }
                            else {
                                //google tag manager
                                var gaData = YouLi.Common.GetGAData("select_promotion");
                                dataLayer.push({ ecommerce: null });
                                dataLayer.push(gaData);

                                var initialSelectedInvoiceAndViewMode = $("input[type=radio][name='CurrentInvitee.GangInvoiceAndViewMode']:checked").val();
                                var initialSelectedPaymentMethod = $("input[type=radio][name=PaymentMethod]:checked").val();
                                var initialSelectedPaymentOption = $("input[type=radio][name=PaymentOption]:checked").val();

                                // when a coupon code is applied, we have to update the installments table, the charge details section and the actual charge form amounts if it is a balance being paid.
                                $("#ChargeDetails").html(response.responseJSON.newCheckoutPaymentChargeDetailsHtml);

                                if ($(".cost-installments-selection").length > 0) {
                                    $(".cost-installments-selection").html(response.responseJSON.newInstallmentsTableHtml);
                                }

                                if (YouLi.Trip.Checkout.SelectedGangInvoiceAndViewMode() != "paytogether") {
                                    $(".cost-line-item-amount-total-invitee").html(YouLi.PaymentChargeForm.GetFormattedCurrency(response.responseJSON.paySeparatelyInviteePrepayTotal));
                                }

                                // update the charge details line item for coupon code
                                $("input[Name=ChargeCouponCode]").val(selectedCouponCode);
                                $(".coupon-code-value").html(selectedCouponCode);
                                $(".cost-line-item-amount-coupon-code").html(`-${YouLi.PaymentChargeForm.GetFormattedCurrency(response.responseJSON.couponCodeAmount)}`);
                                $(".cost-line-item-coupon-code").removeClass("hidden");

                                // if balance is being paid, update the current amount due. For all other installments, we do NOT reduce the amount based on the coupon code.
                                if (response.responseJSON.isBalance) {
                                    YouLi.Trip.Checkout.IsBalanceSelected = true;
                                    YouLi.PaymentChargeForm.AmountDue = response.responseJSON.balanceAmount;
                                    UpdateChargeDetails(undefined);
                                }

                                initialiseValidator();

                                if (!initialSelectedPaymentMethod)
                                    initialSelectedPaymentMethod = $("input[type=radio][name=PaymentMethod]").first().val();
                                if (!initialSelectedPaymentOption)
                                    initialSelectedPaymentOption = $("input[type=radio][name=PaymentOption]").first().val();

                                $("input[type=radio][name='CurrentInvitee.GangInvoiceAndViewMode'][value=" + initialSelectedInvoiceAndViewMode + "]").attr("checked", true);
                                $("input[type=radio][name=PaymentMethod][value=" + initialSelectedPaymentMethod + "]").attr("checked", true);
                                $("input[type=radio][name=PaymentOption][value=" + initialSelectedPaymentOption + "]").attr("checked", true);
                                InitialisePaymentDetails();
                            }
                        }

                    });
                });

                $(document).on("click", ".pay-now-button", function () {

                    // Special: even if the gang email is disabled, we want to enable it to ensure the provided value is VALID
                    $('.gang-email:disabled').each(function () {
                        $(this).prop('disabled', false);
                        $(this).valid();
                        $(this).prop('disabled', true);
                    });

                    var gangFormIsValid = $('#GangSetupForm').valid();

                    var tripConsentFormIsValid = true;
                    if ($("#TripConsentForm").length > 0)
                        tripConsentFormIsValid = $("#TripConsentForm").valid();

                    if (!(gangFormIsValid && tripConsentFormIsValid)) {
                        ScrollToInvalid();
                        return;
                    }

                    YouLi.Trip.Checkout.RefundProtectOptedOutConfirmed = false;

                    if ($("#RefundProtectConfirmationDialog").length > 0 && $("input[type=radio][name='CurrentInvitee.RefundProtectSelection']").length > 0 && $("input[type=radio][name='CurrentInvitee.RefundProtectSelection']:checked").val().toLowerCase() == "optedout") {
                        $("#RefundProtectConfirmationDialog").modal("show");
                        return;
                    }

                    continuePayment();
                });

                $(document).on("click", "#RefundProtectConfirmationFormOk", function () {

                    if (!$("#RefundProtectConfirmationForm").valid())
                        return;

                    $("#RefundProtectConfirmationDialog").modal("hide");

                    YouLi.Trip.Checkout.RefundProtectOptedOutConfirmed = true;

                    continuePayment();
                });

                // The following event handling for the date-time update is now included in the TaskResponseFieldDateTime partial
                function UpdateDateTimeAnswer(element) {
                    var container = element.closest(".date-time-container");
                    var datePicker = $('.datepicker', container).data("DateTimePicker");
                    var timePicker = $('.timepicker', container).data("DateTimePicker");
                    if (!datePicker || datePicker.date() == null || !timePicker || timePicker.date() == null) {
                        $(".combined-date-time-answer", container).val("");
                    }
                    else {
                        $(".combined-date-time-answer", container).val(
                            datePicker.date().format("D/M/Y ") + timePicker.date().format("hh:mm A"));
                    }
                };

                $(document).on("dp.change", ".date-time-container .datepicker", function (e) {
                    UpdateDateTimeAnswer(this);
                });

                $(document).on("dp.change", ".date-time-container .timepicker", function (e) {
                    UpdateDateTimeAnswer(this);
                });

                $(document).on('keypress', '.gang-last-name , .gang-first-name', function (e) {
                    //64 is char '@'
                    if (e.which === 64) {
                        e.preventDefault();
                    }
                });

                $(document).on('click', '.save-card-login a', function (e) {
                    e.preventDefault();
                    const returnUrl = window.location.pathname;
                    const persona = 'traveler';
                    const redirectUrl = $(this).attr('href');

                    window.location.href = `${redirectUrl}?returnUrl=${returnUrl}&defaultPersona=${persona}`;
                })

                InitializeGangEmailEvent();
                //view_item
                var data = YouLi.Common.GetGAData("view_item");
                dataLayer.push({ ecommerce: null });
                dataLayer.push(data);

                //add_to_cart
                var removeFromCartData = YouLi.Common.GetGAData("add_to_cart");
                dataLayer.push({ ecommerce: null });
                dataLayer.push(removeFromCartData);

                prevState.isPackageCategory = $('.gang-member').find('#GangInvitees_0__InviteeCategory').is(':hidden');

                // Trim fields that we do not want to allow spaces in
                $(".trim-before-validation").on("blur", function () {
                    $(this).val($(this).val().trim());
                });
            });

        }(YouLi.Trip.Checkout ? YouLi.Trip.Checkout : {}));
    }(YouLi.Trip ? YouLi.Trip : {}));
}(YouLi ? YouLi : {}));